<template>
    <div class="valid-input-wrapper" :class="{ 'input-has-radius': hasRadius }">
        <input
            :placeholder="placeholder"
            :class="{ 'no-init-border': noInitBorder, 'padding-right-30': showIcon }"
            v-model="value"
            type="text"
            ref="validInput"
            @blur="blurInput"
            @focus="focusInput"
            @keypress="keyPressHandler"
            @input="inputChange"
        />
        <DeleteIcon class="input-delete-icon" @iconClick="iconClick" v-show="showIcon" />
    </div>
</template>

<script>
import DeleteIcon from "@/views/zhiji/bComponents/icons/DeleteIcon";

// initValue:string, hasRadus:true|false, messages: {tips, error} tips输入时提示，error错误时提示
export default {
    name: "ValidateInput",
    props: ["placeholder", "initValue", "hasRadius", "messages", "noInitBorder", "noIcon"],
    components: {
        DeleteIcon
    },
    data() {
        return {
            value: this.initValue || ""
        };
    },
    computed: {
        showIcon() {
            return !this.noIcon && this.value != "";
        }
    },
    watch: {
        initValue(newVal) {
            this.value = newVal;
        }
    },
    methods: {
        iconClick() {
            this.value = "";
            this.inputChange();
        },
        blurInput() {
            this.$emit("inputBlur");
            this.$store.commit("zhiji/hideMessageTip");
        },
        focusInput() {
            this.$emit("inputFoucs");
            this.messages &&
                this.messages.tips &&
                this.$store.commit("zhiji/showMessageTip", {
                    message: this.messages.tips,
                    target: this.$refs.validInput
                });
        },
        inputChange() {
            this.$emit("inputChange", this.value);
        },
        keyPressHandler(event) {
            const isEnterKey = event.keyCode === 13;
            isEnterKey && this.$emit("confirmPress", this.value);
        }
    }
};
</script>

<style scoped lang="scss">
.valid-input-wrapper {
    position: relative;
    width: 200px;
    height: 40px;
    box-sizing: border-box;
    input {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        color: #41475e;
        font-size: 12px;
        outline: none;
        border: 1px solid #d8e4f0;
        text-indent: 8px;
        background: #fff;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        &:focus {
            border: 1px solid #2088f3;
        }
    }

    .padding-right-30 {
        padding-right: 30px;
    }

    .no-init-border {
        border: 1px solid transparent;
    }

    .input-delete-icon {
        position: absolute;
        right: 8px;
        top: 50%;
        transform: translateY(-50%);
        z-index: 1;
    }

    &.input-has-radius {
        border-radius: 4px;

        input {
            border-radius: 4px;
        }
    }
}
</style>
